import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettings } from '../enums/app-settings.enum';
import { EnvironmentConfigurations } from '../models/EnvironmentConfigurations';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInitializationService {

  environmentConfig: EnvironmentConfigurations;

    constructor(private http: HttpClient) { }

    initializeApp() {
        return this.http.get(environment?.B2C_URL + '/getEnvironmentConfigurations.service').toPromise()
            .then(async (response: any) => {
                this.environmentConfig = response?.hybridEnvironmentConfigurations?.HYBRID_DYNAMIC_CONFIGS;
                this.environmentConfig.CMS_URL_NEW_FRAGMENTPATH = response?.hybridEnvironmentConfigurations?.CMS_URL_NEW_FRAGMENTPATH + '/etisalat/nwt-consumer-generic;fragmentpath=';
                this.environmentConfig.CMS_URL_NEW_FRAGMENTPATH_EAND = response?.hybridEnvironmentConfigurations?.CMS_URL_NEW_FRAGMENTPATH_EAND + '/etisalat/nwt-consumer-generic;fragmentpath=';
            })
            .catch((error) => {
                // When service fails, get the configurations from the backup
                this.prepareConfigurationBackup();

            });
    }

    prepareConfigurationBackup() {
        // this.environmentConfig.CMS_HOST = environment?.CMS_HOST;
        // this.environmentConfig.GTM = environment?.GTM;
        // this.environmentConfig.ADOBE_SCRIPT = AppSettings.ADOBE_BACKUP_SCRIPT;
    }
}
